import React from 'react'

import clsx from 'clsx'

import Close from '~/images/icons/SystemOutlined/Close.svg'
import BackdropBase from '~/ui/BackdropBase/BackdropBase'

interface ModalBaseProps {
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
  className?: string
}

const Modal: React.FC<ModalBaseProps> = ({ isOpen, onClose, children, className }) => {
  return (
    <BackdropBase isOpen={isOpen} onClose={onClose}>
      <div
        className={clsx(
          'z-10 bg-white shadow-lg w-full max-w-[min(96vw,600px)] max-h-[96vh] overflow-y-auto',
          className,
        )}
      >
        {children}
      </div>
    </BackdropBase>
  )
}
export const ModalHeader = ({
  children,
  className = '',
  onClose,
}: {
  children: React.ReactNode
  className?: string
  onClose?: () => void
}) => (
  <div className={`${className}`}>
    {onClose && (
      <button onClick={onClose} className='absolute top-4 right-4 text-gray-600 hover:text-gray-800'>
        <Close title='close' width={24} height={24} />
      </button>
    )}
    {children}
  </div>
)

export const ModalBody = ({ children, className = '' }: { children: React.ReactNode; className?: string }) => (
  <div className={`${className}`}>{children}</div>
)

export const ModalFooter = ({ children, className = '' }: { children: React.ReactNode; className?: string }) => (
  <div className={`${className}`}>{children}</div>
)

export default Modal
